<template>
    <FormInputContainer class="FormDateTimeInput" :inputId="`I${_uid}`" :label="label" :errors="errors" :required="required">
        <FlatPickr
            :id="`I${_uid}`"
            v-bind="$attrs"
            :value="value"
            :config="config"
            @on-change="handleChange"
        />
    </FormInputContainer>
</template>


<script>
import { format } from 'date-fns';
import FormInputContainer from './FormInputContainer';
import FlatPickr from 'vue-flatpickr-component';
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';

export default {
    name: 'FormDateTimeInput',
    inheritAttrs: false,

    components: { FlatPickr, FormInputContainer },

    props: {
        value: { type: String },
        label: { type: String },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },

    data: () => ({
        config: {
            dateFormat: 'M j, Y, h:i K',
            enableTime: true,
            minuteIncrement: 1,
            defaultHour: format(new Date(), 'H'),
            defaultMinute: format(new Date(), 'm'),
            plugins: [new ConfirmDatePlugin()],
        },
    }),

    methods: {
        handleChange(event) {
            // Convert to ISO string date and remove seconds/milliseconds.
            const date = event[0].toISOString().replace(/\d+\.\d+Z/, '00.000Z');
            this.$emit('input', date);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormDateTimeInput {
    input {
        @extend %form-control;
    }
}
</style>
